export interface ObjectRefTarget {
  id: string;
  entityType?: string | null;
}

/** URL for an objectRef chip: entity page when typed, else the canvas editor by id. */
export function objectRefUrl(ref: ObjectRefTarget): string {
  const id = ref?.id ?? '';
  if (ref?.entityType) return `/dashboard/entities/${ref.entityType}/${id}`;
  return `/dashboard/editor?id=${id}`;
}
